<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
  >
    <BackgroundImage />
    <DocumentLink :isShow="!group1.isCustomize" />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <!-- マイリンク -->
    <transition name="popup">
      <PCMyLinkList
        v-if="group1.visibleMyLinkList"
        :parentMyLinkList="group1.mylink_list"
        @loadMyLink="group1.loadMyLink"
        @closeMyLinkList="group1.visibleMyLinkList = false"
      />
    </transition>

    <!-- システムエラー -->
    <transition name="popup">
      <PCSystemError
        v-if="visibleSystemError"
        @closeSystemError="visibleSystemError = false"
      />
    </transition>

    <!-- ウィジェット並び替えウィンドウ -->
    <transition name="popup">
      <PCDashboardChangePosition
        v-if="group1.isChangeOrderWindowShown"
        @moveWidgetToTop="group1.moveWidgetToTop"
        @moveWidgetUpOne="group1.moveWidgetUpOne"
        @moveWidgetDownOne="group1.moveWidgetDownOne"
        @moveWidgetToBottom="group1.moveWidgetToBottom"
        @closeDashboardChangePosition="group1.isChangeOrderWindowShown = false"
      />
    </transition>


    <!-- カスタマイズ時表示項目 -->
    <div v-if="group1.isCustomize" class="footer-fixed">
      <div class="button save">
        <span @click="group1.onSaveAndQuitCustomizeButtonClicked" class="btn" role="button">カスタマイズを保存して終了する</span> 
      </div>
      <span @click="group1.onInitializeCustomizeButtonClicked" class="init" role="button">カスタマイズを初期化する</span>
    </div>


    <div id="wrapper">
      <!-- header:start -->
      <PCSearchUI 
        :screenType="'dashboard'"
        :isAlertShown="true"
        @search="group1.search"
      />
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
        >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content">
        <main class="" id="main">
          <div class="box02 white" id="scroll-target"
            @scroll="handleScroll"
            style="height:calc(100vh - 16px);"
            >
            <!-- 重要なお知らせ -->
            <div v-if="group1.important_information_list.length > 0" class="box02-hdg">
              <ul class="box02-hdg-list">
                <li class="box02-hdg-list-item"
                  v-for="(item, index) in group1.important_information_list" :key="'important_information_' + index">
                  <span class="box02-hdg-list-item-date">{{ item.publication_day }}</span>
                  <span v-if="item.type === 1" class="box02-hdg-list-item-title-no-link">{{item.title}}</span>
                  <a v-else-if="item.type === 2" :href="item.url" target="_blank" class="box02-hdg-list-item-title" role="button">{{item.title}} <FontawesomeIcon :icon="['far','external-link']" class="icn" /></a>
                  <a v-else-if="item.type === 3" @click.stop.prevent="group1.goToInformationPage(item.id)" class="box02-hdg-list-item-title" role="button">{{item.title}}</a>
                </li>
              </ul>
            </div>
            <div class="box02-body">
              <div class="dashboard">
                <!-- マイリンク -->
                <div 
                  v-show="(group1.isCustomize || (!group1.isCustomize && group1.mylink_isVisible && group1.mylink_list.length > 0)) && !isFromAdminSystem()" 
                  class="dashboard-menu"
                  :class="{'is-hidden': group1.isCustomize && !group1.mylink_isVisible}"
                >
                  <a v-for="(item, index) in group1.mylink_list" :key="'mylink_' + index" 
                  :href="item.url" 
                  :target="item.new_window === 1 ? '_blank' : false" 
                  class="dashboard-menu-link">{{ item.title }}<FontawesomeIcon v-if="item.new_window === 1" class="icn" :icon="['fa','external-link']" /></a>

                  <!-- カスタマイズモード表示項目 -->
                  <p v-if="group1.isCustomize && group1.mylink_list.length === 0" class="no-link">マイリンク</p>
                  <div v-if="group1.isCustomize" class="dashboard-menu-icon">
                    <div @click="group1.changeMyLinkVisible" class="dashboard-menu-icon-link" role="button">
                      <template v-if="!group1.mylink_isVisible">
                        <span class="dashboard-menu-icon-link-tip">非表示</span>
                        <FontawesomeIcon class="icn" :icon="['far','eye-slash']" />
                      </template>
                      <template v-else>
                        <span class="dashboard-menu-icon-link-tip">表示</span>
                        <FontawesomeIcon class="icn" :icon="['far','eye']" />
                      </template>
                    </div>
                    <div class="dashboard-menu-icon-link" role="button"
                      @click="group1.visibleMyLinkList = true"
                      >編集
                      <!-- <FontawesomeIcon class="icn" :icon="['far','wrench']" /> -->
                    </div>
                  </div>

                </div>

                <!-- カスタマイズ時表示項目 -->
                <!-- 1カラム・2カラム切り替えボタン -->
                <div v-if="group1.isCustomize" class="dashboard-views">
                  <div class="dashboard-views-container">
                    <div class="box col-1" role="button"
                      @click="group1.changeColumn(1)"
                      :class="{'is-active': group1.columns === 1}"
                    >
                      <div class="block">
                        <div></div>
                      </div>
                      <div class="text">1カラム</div>
                    </div>
                    <div class="box col-2" role="button"
                      @click="group1.changeColumn(2)"
                      :class="{'is-active': group1.columns === 2}"
                    >
                      <div class="block">
                        <div></div><div></div>
                      </div>
                      <div class="text">2カラム</div>
                    </div>
                  </div>
                </div>

                <ul class="dashboard-list" :class="group1.columns === 2 ? 'is-2column' : 'is-1column'">
                  <template v-for="(orderItem, orderIndex) in group1.order">

                    <!-- ウィジェット：お知らせ -->
                    <li 
                      :key="'order_information_' + orderIndex"
                      v-if="orderItem === 'information'"
                      v-show="group1.isCustomize || (!group1.isCustomize && group1.information_isVisible)"
                      class="dashboard-list-item information"
                      :class="{'is-hidden': group1.isCustomize && !group1.information_isVisible}"
                    >
                      <div class="dashboard-hdg">
                        <h2 class="dashboard-hdg-title">お知らせ</h2>
                        <div class="dashboard-hdg-aside">
                          <router-link to="/pc/information-list" class="dashboard-hdg-aside-link" role="button">一覧を表示</router-link>

                          <!-- カスタマイズ時表示項目 -->
                          <PCDashboardWidgetCustomizeParts 
                            v-if="group1.isCustomize"
                            :widgetType="'information'"
                            :parentGroup1="{isVisible: group1.information_isVisible, count: group1.information_count}"
                            @changeVisible="group1.changeWidgetVisible"
                            @changeCount="group1.changeWidgetCount"
                            @openWidgetChangePositionWindow="group1.openWidgetChangePositionWindow"
                          />

                        </div>
                      </div>
                      <div class="dashboard-content">
                        <ul v-if="group1.information_category_list.length > 0" class="tab">
                          <li v-for="(item, index) in group1.information_category_list"
                            :key="'information_category_' + index"
                            @click="group1.loadInformation(item.code)"
                            :class="{'is-active': item.code !== group1.targetInformationCategoryCode}"
                            :role="item.code !== group1.targetInformationCategoryCode ? 'button' : ''"
                            >{{ item.value1 }}
                          </li>
                        </ul>

                        <FontawesomeIcon v-if="!group1.isInformationDataLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                        <template v-else>
                          <p v-if="group1.information_list.length === 0">表示する内容がありません。</p>
                          <template v-else>
                            <ul class="list">
                              <li v-for="(item, index) in group1.information_list" :key="'information_' + index" class="list-item">
                                <div class="row">
                                  <div class="date">{{ item.publication_day }}</div>
                                  <span v-if="item.classification === 3 || item.classification === 2"
                                    class="label" :class="item.classification === 3 ? 'red' : 'gray'"
                                    >{{ item.classification_name }}</span>
                                  <span class="category">{{ item.category_name }}</span>
                                </div>
                                <div class="detail">
                                  <span v-if="item.type === 1" class="no-link">{{item.title}}</span>
                                  <a v-else-if="item.type === 2" :href="item.url" target="_blank" class="txt-blue" role="button">{{item.title}} <FontawesomeIcon :icon="['far','external-link']" class="icn" /></a>
                                  <a v-else-if="item.type === 3" @click.stop.prevent="group1.goToInformationPage(item.id)" class="txt-blue" role="button">{{item.title}}</a>
                                  <p class="text">{{ item.summary }}</p>
                                </div>
                              </li>
                            </ul>
                          </template>
                        </template>
                      </div>
                    </li>

                    <!-- ウィジェット：最新ナレッジ -->
                    <li 
                      :key="'order_knowledge_' + orderIndex"
                      v-if="orderItem === 'knowledge' && !isFromAdminSystem()"
                      v-show="group1.isCustomize || (!group1.isCustomize && group1.knowledge_isVisible)"
                      class="dashboard-list-item knowledge"
                      :class="{'is-hidden': group1.isCustomize && !group1.knowledge_isVisible}"
                    >
                      <div class="dashboard-hdg">
                        <h2 class="dashboard-hdg-title">最新ナレッジ</h2>
                        <div class="dashboard-hdg-aside">
                          <router-link to="/pc/knowledge-list" class="dashboard-hdg-aside-link" role="button">一覧を表示</router-link>

                          <!-- カスタマイズ時表示項目 -->
                          <PCDashboardWidgetCustomizeParts 
                            v-if="group1.isCustomize"
                            :widgetType="'knowledge'"
                            :parentGroup1="{isVisible: group1.knowledge_isVisible, count: group1.knowledge_count}"
                            @changeVisible="group1.changeWidgetVisible"
                            @changeCount="group1.changeWidgetCount"
                            @openWidgetChangePositionWindow="group1.openWidgetChangePositionWindow"
                          />

                        </div>
                      </div>
                      <div class="dashboard-content">
                        <FontawesomeIcon v-if="!group1.isKnowledgeDataLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                        <template v-else>
                          <p v-if="group1.knowledge_list.length === 0">表示する内容がありません。</p>
                          <ul v-else class="list">
                            <li v-for="(item, index) in group1.knowledge_list" :key="'knowledge_' + index" class="list-item">
                              <div class="date">{{ item.created }}</div>
                              <a @click.stop.prevent="group1.goToKnowledgePage(item.id)" class="link" role="button"
                              ><span class="parent-knowledge-category" v-if="item.knowledge_type_name">[{{item.knowledge_type_name}}]</span>{{ item.title }}</a>
                            </li>
                          </ul>
                        </template>
                      </div>
                    </li>

                    <!-- ウィジェット：書籍 -->
                    <li 
                      :key="'order_book_' + orderIndex"
                      v-if="orderItem === 'book'"
                      v-show="group1.isCustomize || (!group1.isCustomize && group1.book_isVisible)"
                      class="dashboard-list-item books"
                      :class="{'is-hidden': group1.isCustomize && !group1.book_isVisible}"
                    >
                      <div class="dashboard-hdg">
                        <h2 class="dashboard-hdg-title">書籍</h2>
                        <div class="dashboard-hdg-aside">
                          <router-link to="/pc/book-list" class="dashboard-hdg-aside-link" role="button">一覧を表示</router-link>

                          <!-- カスタマイズ時表示項目 -->
                          <PCDashboardWidgetCustomizeParts 
                            v-if="group1.isCustomize"
                            :widgetType="'book'"
                            :parentGroup1="{isVisible: group1.book_isVisible, count: group1.book_count}"
                            @changeVisible="group1.changeWidgetVisible"
                            @changeCount="group1.changeWidgetCount"
                            @openWidgetChangePositionWindow="group1.openWidgetChangePositionWindow"
                          />

                        </div>
                      </div>
                      <div class="dashboard-content"
                        :style="{maxHeight: books.height + 'px'}"
                      >
                        <FontawesomeIcon v-if="!group1.isBookDataLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                        <template v-else>
                          <p v-if="group1.book_product_list.length === 0 && group1.book_book_list.length === 0">表示する内容がありません。</p>
                          <template v-else>
                            <template v-for="(item, index) in group1.book_product_list">
                              <div :key="'book_category_' + index" class="category">{{ item.name }}</div>
                              <ul :key="'book_product_list_' + index" class="list-package">
                                <li v-for="(item2, index2) in item.books" :key="'books_' + index2" class="list-item">
                                  <a @click.stop.prevent="group1.goToBookPage(item2.product_id, item2.book_id, item2.name)" class="link" role="button">{{ item2.name }}</a>
                                </li>
                              </ul>
                            </template>
                            <template v-if="group1.book_book_list.length > 0">
                              <ul :class="{'mt40' : group1.book_product_list.length > 0}" class="list-single">
                                <li v-for="(item, index) in group1.book_book_list" :key="'book_book_' + index" class="list-item">
                                  <a @click.stop.prevent="group1.goToBookPage(item.product_id, item.book_id, item.name)" class="link" role="button">{{ item.name }}</a>
                                </li>
                              </ul>
                            </template>

                          </template>
                        </template>
                      </div>
                    </li>

                    <!-- ウィジェット：ノート -->
                    <li 
                      :key="'order_note_' + orderIndex"
                      v-if="orderItem === 'note' && !isFromAdminSystem()"
                      v-show="group1.isCustomize || (!group1.isCustomize && group1.note_isVisible)"
                      class="dashboard-list-item note"
                      :class="{'is-hidden': group1.isCustomize && !group1.note_isVisible}"
                    >
                      <div class="dashboard-hdg">
                        <h2 class="dashboard-hdg-title">ノート</h2>
                        <div class="dashboard-hdg-aside">
                          <router-link to="/pc/note-list" class="dashboard-hdg-aside-link" role="button">一覧を表示</router-link>

                          <!-- カスタマイズ時表示項目 -->
                          <PCDashboardWidgetCustomizeParts 
                            v-if="group1.isCustomize"
                            :widgetType="'note'"
                            :parentGroup1="{isVisible: group1.note_isVisible, count: group1.note_count}"
                            @changeVisible="group1.changeWidgetVisible"
                            @changeCount="group1.changeWidgetCount"
                            @openWidgetChangePositionWindow="group1.openWidgetChangePositionWindow"
                          />

                        </div>
                      </div>
                      <div class="dashboard-content">
                        <FontawesomeIcon v-if="!group1.isNoteDataLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                        <template v-else>
                          <p v-if="group1.note_list.length === 0">表示する内容がありません。</p>
                          <ul v-else class="list">
                            <li v-for="(item, index) in group1.note_list" :key="'note_' + index" class="list-item">
                              <div class="date">{{ formatDate(item.modified) }}</div>
                              <a @click.stop.prevent="group1.goToNotePage(item.id)" class="link" role="button">{{ item.title }}</a>
                              <div v-if="item.user_file_id > 0" class="prof" :style="[item.image && {backgroundImage : 'url(' + item.image + ')'}]"></div>
                              <div v-else class="prof no-image">{{item.create_user_name.slice(0, 1)}}</div>
                            </li>
                          </ul>
                        </template>
                      </div>
                    </li>

                    <!-- ウィジェット：後で見る -->
                    <li 
                      :key="'order_viewLater_' + orderIndex"
                      v-if="orderItem === 'view-later' && !isFromAdminSystem()"
                      v-show="group1.isCustomize || (!group1.isCustomize && group1.viewLater_isVisible)"
                      class="dashboard-list-item view-lator"
                      :class="{'is-hidden': group1.isCustomize && !group1.viewLater_isVisible}"
                    >
                      <div class="dashboard-hdg">
                        <h2 class="dashboard-hdg-title">後で見る</h2>
                        <div class="dashboard-hdg-aside">
                          <router-link to="/pc/view-later-list" class="dashboard-hdg-aside-link" role="button">一覧を表示</router-link>

                          <!-- カスタマイズ時表示項目 -->
                          <PCDashboardWidgetCustomizeParts 
                            v-if="group1.isCustomize"
                            :widgetType="'view-later'"
                            :parentGroup1="{isVisible: group1.viewLater_isVisible, count: group1.viewLater_count}"
                            @changeVisible="group1.changeWidgetVisible"
                            @changeCount="group1.changeWidgetCount"
                            @openWidgetChangePositionWindow="group1.openWidgetChangePositionWindow"
                          />

                        </div>
                      </div>
                      <div class="dashboard-content">
                        <FontawesomeIcon v-if="!group1.isViewLaterDataLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                        <template v-else>
                          <p v-if="group1.viewLater_list.length === 0">表示する内容がありません。</p>
                          <ul v-else class="list">
                            <li v-for="(item, index) in group1.viewLater_list" :key="'viewLater_' + index" class="list-item">
                              <div class="date">{{ item.created }}</div>
                              <span v-if="item.deleted == 1 || item.auth_message" class="link no-link">{{ item.title }}</span>
                              <a v-else @click.stop.prevent="group1.goToViewLaterPage(item)" class="link" role="button">{{ item.title }}</a>
                            </li>
                          </ul>
                        </template>
                      </div>
                    </li>

                    <!-- ウィジェット：ブックマーク -->
                    <li 
                      :key="'order_bookmark_' + orderIndex"
                      v-if="orderItem === 'bookmark' && !isFromAdminSystem()"
                      v-show="group1.isCustomize || (!group1.isCustomize && group1.bookmark_isVisible)"
                      class="dashboard-list-item bookmark"
                      :class="{'is-hidden': group1.isCustomize && !group1.bookmark_isVisible}"
                    >
                      <div class="dashboard-hdg">
                        <h2 class="dashboard-hdg-title">ブックマーク</h2>
                        <div class="dashboard-hdg-aside">
                          <router-link to="/pc/bookmark-list" class="dashboard-hdg-aside-link" role="button">一覧を表示</router-link>

                          <!-- カスタマイズ時表示項目 -->
                          <PCDashboardWidgetCustomizeParts 
                            v-if="group1.isCustomize"
                            :widgetType="'bookmark'"
                            :parentGroup1="{isVisible: group1.bookmark_isVisible, count: group1.bookmark_count}"
                            @changeVisible="group1.changeWidgetVisible"
                            @changeCount="group1.changeWidgetCount"
                            @openWidgetChangePositionWindow="group1.openWidgetChangePositionWindow"
                          />

                        </div>
                      </div>
                      <div class="dashboard-content">
                        <FontawesomeIcon v-if="!group1.isBookmarkDataLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                        <template v-else>
                          <p v-if="group1.bookmark_list.length === 0">表示する内容がありません。</p>
                          <ul v-else class="list">
                            <li v-for="(item, index) in group1.bookmark_list" :key="'bookmark_' + index" class="list-item">
                              <div class="date">{{ item.created }}</div>
                              <span v-if="item.deleted == 1 || item.auth_message" class="link no-link">{{ item.title }}</span>
                              <a v-else @click.stop.prevent="group1.goToBookmarkPage(item)" class="link" role="button">{{ item.title }}</a>
                            </li>
                          </ul>
                        </template>
                      </div>
                    </li>

                    <!-- ウィジェット：書式ダウンロード -->
                    <li 
                      :key="'order_documentDownload_' + orderIndex"
                      v-if="orderItem === 'document-download'"
                      v-show="group1.isCustomize || (!group1.isCustomize && group1.documentDownload_isVisible)"
                      class="dashboard-list-item document-download"
                      :class="{'is-hidden': group1.isCustomize && !group1.documentDownload_isVisible}"
                    >
                      <div class="dashboard-hdg">
                        <h2 class="dashboard-hdg-title">書式ダウンロード</h2>
                        <div class="dashboard-hdg-aside">
                          <router-link to="/pc/document-downloads-list" class="dashboard-hdg-aside-link" role="button">一覧を表示</router-link>

                          <!-- カスタマイズ時表示項目 -->
                          <PCDashboardWidgetCustomizeParts 
                            v-if="group1.isCustomize"
                            :widgetType="'document-download'"
                            :parentGroup1="{isVisible: group1.documentDownload_isVisible, count: group1.documentDownload_count}"
                            @changeVisible="group1.changeWidgetVisible"
                            @changeCount="group1.changeWidgetCount"
                            @openWidgetChangePositionWindow="group1.openWidgetChangePositionWindow"
                          />

                        </div>
                      </div>
                      <div class="dashboard-content"
                        :style="{maxHeight: documentDownload.height + 'px'}"
                      >
                        <FontawesomeIcon v-if="!group1.isDocumentDownloadDataLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                        <template v-else>
                          <p v-if="group1.documentDownload_list.length === 0">表示する内容がありません。</p>
                          <ul v-else class="list">
                            <li v-for="(item, index) in group1.documentDownload_list" :key="'documentDownload_' + index" class="list-item">
                              <a @click.stop.prevent="group1.goToDocumentDownload(item.id, item.name)" class="link" role="button">{{ item.name }}</a>
                            </li>
                          </ul>
                          </template>
                      </div>
                    </li>

                    <!-- ウィジェット：閲覧履歴 -->
                    <li 
                      :key="'order_historyOfView_' + orderIndex"
                      v-if="orderItem === 'history-of-view' && !isFromAdminSystem()"
                      v-show="group1.isCustomize || (!group1.isCustomize && group1.historyOfView_isVisible)"                      
                      class="dashboard-list-item history-of-view"
                      :class="{'is-hidden': group1.isCustomize && !group1.historyOfView_isVisible}"
                    >
                      <div class="dashboard-hdg">
                        <h2 class="dashboard-hdg-title">閲覧履歴</h2>
                        <div class="dashboard-hdg-aside">
                          <router-link to="/pc/history-of-view" class="dashboard-hdg-aside-link" role="button">一覧を表示</router-link>

                          <!-- カスタマイズ時表示項目 -->
                          <PCDashboardWidgetCustomizeParts 
                            v-if="group1.isCustomize"
                            :widgetType="'history-of-view'"
                            :parentGroup1="{isVisible: group1.historyOfView_isVisible, count: group1.historyOfView_count}"
                            @changeVisible="group1.changeWidgetVisible"
                            @changeCount="group1.changeWidgetCount"
                            @openWidgetChangePositionWindow="group1.openWidgetChangePositionWindow"
                          />

                        </div>
                      </div>
                      <div class="dashboard-content">
                        <FontawesomeIcon v-if="!group1.isHistoryOfViewDataLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                        <template v-else>
                          <p v-if="group1.historyOfView_list.length === 0">表示する内容がありません。</p>
                          <ul v-else class="list">
                            <li v-for="(item, index) in group1.historyOfView_list" :key="'historyOfView_' + index" class="list-item">
                              <div class="date">{{ item.date }}</div>
                              <div class="category">{{ item.type_name }}</div>
                              <span v-if="item.deleted == 1 || item.auth_message" class="link no-link">{{ item.title }}</span>
                              <a v-else @click.stop.prevent="group1.goToHistoryOfViewPage(item)" class="link" role="button">{{ item.title }}</a>
                            </li>
                          </ul>
                        </template>
                      </div>
                    </li>

                  </template>
                </ul>

                <div v-if="!group1.isCustomize && !isFromAdminSystem()" class="dashboard-custom">
                  <span @click="group1.onCustomizeButtonClicked" class="text ga-dashboard-customize" role="button">ダッシュボードのカスタマイズ</span>
                </div>

                <footer class="dashboard-footer">
                  <ul class="list">
                    <template v-if="group1.isAdmin && !isFromAdminSystem()">
                      <li v-if="!group1.isWLJOP"><router-link to="/pc/contract">契約情報</router-link></li>
                      <li v-if="!group1.isWLJOP"><router-link to="/pc/service">サービス管理</router-link></li>
                      <li><router-link to="/pc/contract-account">利用者アカウント管理</router-link></li>
                      <li><router-link to="/pc/contract-assign-license">ライセンスの付与</router-link></li>
                      <li v-if="!group1.isWLJOP"><router-link to="/pc/contract-history-of-purchase">申し込み履歴</router-link></li>
                    </template>
                    <li><router-link to="/pc/inquiry-input">お問い合わせ</router-link></li>
                  </ul>
                  <ul class="list">
                    <li><router-link to="/pc/guide/index">ご利用ガイド</router-link></li>
                  </ul>
                  <ul class="list sm">
                    <li><a href="https://www.sn-hoki.co.jp/guide/social_rules/" target="_blank">利用規約 <FontawesomeIcon icon="external-link-alt" class="icn" /></a></li>
                    <li><a href="https://www.sn-hoki.co.jp/privacy/" target="_blank">プライバシーポリシー <FontawesomeIcon icon="external-link-alt" class="icn" /></a></li>
                    <li><a href="https://www.sn-hoki.co.jp/guide/tradelaw/" target="_blank">特定商取引法に基づく表記 <FontawesomeIcon icon="external-link-alt" class="icn" /></a></li>
                  </ul>
                  <p class="copy">Copyright (C) 2021 SHINNIPPON-HOKI PUBLISHING CO.,LTD.</p>
                </footer>
              </div>
            </div>
          </div>
        </main>
      </div>
      <!-- content:end -->

      <span id="btnTop" @click="scrollAreaTop('#scroll-target')" :class="{'is-slideup': group1.isCustomize}">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'

import PCDashboardWidgetCustomizeParts from '@/components/pc/partial/PCDashboardWidgetCustomizeParts.vue'
import PCDashboardChangePosition from '@/components/pc/popup/PCDashboardChangePosition.vue'

import PCSearchUI from '@/components/pc/partial/PCSearchUI'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCMyLinkList from '@/components/pc/popup/PCMyLinkList.vue'
import PCCustomizationInitializeConfirm from '@/components/pc/popup/PCCustomizationInitializeConfirm.vue'
import PCBasicToast from '@/components/pc/popup/PCBasicToast.vue'

import * as logicDashboard from '@/logic/dashboard/Dashboard'
import { isFromAdminSystem, formatDate } from '@/util/common'


export default defineComponent({
  components: {
    PCDashboardWidgetCustomizeParts,
    PCDashboardChangePosition,
    PCSearchUI,
    PCMenu,
    PCMyLinkList,
    PCCustomizationInitializeConfirm,
    PCBasicToast
  },  
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const { group1, searchSelect } = logicDashboard.getGroup(props, context)

    const state = reactive({
      visibleToast: false,
      visibleCustomizationInitializeConfirm: false,
      // visibleSearchDetail: false,
      isVisibleContent: true
      // isOpenMenuArrow: false
    })

    const books = reactive({
      height: computed(() => {
        // 書籍ウィジェットの高さはカスタマイズの1～30の値によって決まる
        return 76 + group1.book_count * 33
      })
    })
    const documentDownload = reactive({
      rows: 5, // default
      height: computed(() => {
        return 32 + documentDownload.rows * 40
      })
    })


    return {
      group1,
      isFromAdminSystem,
      formatDate,
      state,
      books,
      documentDownload,
      searchSelect
    }
  }
})
</script>

<style lang="scss" scoped>
// .header {
//   &-search {
//     &-title {
//       padding-right: 10px;
//       min-width: 230px;
//       .formparts.select {
//         .select-label {
//           color: #fff;
//           font-size: bold;
//           font-size: 1.8rem;
//         }
//         .select-option label {
//           font-size: 1.6rem;
//           color: $color-content;
//         }
//       }
//     }
//     &-alert {
//       position: absolute;
//       top: 20px;
//       right: 40px;
//       @include hoverOpacity;
//       .icn {
//         transform: rotate(45deg);
//         margin-right: 5px;
//       }
//       .num {
//         font-size: 1.4rem;
//         color: $color-link;
//         display: inline-flex;
//         justify-content: center;
//         align-items: center;
//         width: 28px;
//         height: 28px;
//         border-radius: 50%;
//         background-color: #fff;
//       }
//     }
//   }
// }
#main {
  width: 100%;
  margin-left: 0;
}
.box02 {
  overflow-y: auto;
  &-hdg {
    border-radius: 0!important;
    &-list {
      list-style: none;
      &-item {
        display: flex;
        &:nth-child(n+2) {
          margin-top: 16px;
        }
        &-date {
          width: 100px;
          padding-right: 10px;
        }
        &-title {
          width: calc(100% - 100px);
          &:hover {
            text-decoration: underline;
          }
        }
        &-title-no-link {
          width: calc(100% - 100px);
        }
      }
    }
  }
}
a.box02-hdg-list-item-title{
  color: #005BAC !important;
}

.dashboard {
  position: relative;
  padding: 20px 0;
  &-menu {
    text-align: right;
    margin-bottom: 30px;
    padding: 0 40px;
    &-link {
      color: $color-link;
      display: inline-flex;
      align-items: center;
      font-size: 1.2rem;
      @include hoverOpacity;
      .icn {
        margin-left: 5px;
      }
      & + .dashboard-menu-link {
        margin-left: 20px;
      }
    }
    & .no-link {
      color: $color-content;
      display: inline-flex;
      align-items: center;
      font-size: 1.2rem;
      margin-left: 20px;
    }
    &-icon {
      display: inline-block;
      border-left: 1px solid $color-line;
      margin-left: 20px;
      &-link {
        position: relative;
        display: inline-block;
        margin-left: 20px;
        @include hoverOpacity;
        color: $color-link;
        font-size: 1.4rem;
        &-tip {
          white-space: nowrap;
          font-size: 1.4rem;
          position: absolute;
          top: -20px;
          left: -6px;
          opacity: 0;
          transition: opacity .2s;
        }
        &:hover {
          .dashboard-menu-icon-link-tip {
            opacity: 1;
          }
        }
      }
    }
  }
  &-content {
    z-index: 1;
    padding: 32px 40px;
    border-top: 1px solid $color-line;
    .link {
      display: block;
      color: $color-link;
      font-size: 1.6rem;
      &.no-link {
        color: $color-content;
      }
    }
    .date,.category,.text {
      color: $color-content;
      font-size: 1.6rem;
    }
    .list {
      list-style: none;
      &-item {
        &:nth-child(n+2) {
          margin-top: 12px;
        }
      }
    }
  }
  &-list {
    list-style: none;
    padding: 0 40px;
    &-item {
      position: relative;
      border: 1px solid $color-line;
      border-radius: 4px;
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
      &.is-hidden {
        background-color: $color-bg-paper;
        .dashboard-hdg {
          color: $color-inactive;
        }
        .dashboard-hdg-aside-link {
          color: $color-inactive;
          pointer-events: none;
        }
        .dashboard-content {
          display: none;
        }
      }
      &:nth-of-type(1){
        z-index: 100;
      }
      &:nth-of-type(2){
        z-index: 90;
      }
      &:nth-of-type(3){
        z-index: 80;
      }
      &:nth-of-type(4){
        z-index: 70;
      }
      &:nth-of-type(5){
        z-index: 60;
      }
      &:nth-of-type(6){
        z-index: 50;
      }
      &:nth-of-type(7){
        z-index: 40;
      }
      &:nth-of-type(8){
        z-index: 30;
      }
      &:nth-of-type(9){
        z-index: 20;
      }
    }
    &.is-2column {
      column-count: 2;
      column-gap: 40px;
      .dashboard-list-item {
        display: block;
        page-break-inside: avoid;
        break-inside: avoid;
      }
      .view-lator,
      .knowledge,
      .bookmark {
        .list-item {
          display: block;
        }
        .link {
          margin-top: 4px;
        }
      }
      .note {
        .list-item {
          flex-wrap: wrap;
          .link {
            width: calc(100% - 50px);
          }
        }
      }
      .history-of-view {
        .list-item {
          flex-wrap: wrap;
          .link {
            width: 100%;
            margin-top: 4px;
          }
        }
      }
      .information {
        .list-item {
          .detail {
            margin-left: 0;
          }
        }
      }
    }
  }
  &-hdg {
    z-index: 2;
    position: relative;
    color: $color-hdg;
    font-size: 2.0rem;
    padding: 24px 40px;
    &-title {
      font-size: 2.0rem;
      color: $color-hdg;
      &-2 {
        font-size: 1.8rem;
        color: $color-hdg;
        vertical-align: middle;
      }
    }
    &-aside {
      position: absolute;
      right: 40px;
      top: 50%;
      transform: translate3d(0,-50%,0);
      font-size: 1.4rem;
      display: flex;
      align-items: center;
      &-link {
        color: $color-link;
        @include hoverOpacity;
      } 
      ::v-deep &-menu {
        display: flex;
        align-items: center;
        border-left: 1px solid $color-line;
        margin-left: 20px;
        .view,
        .position,
        .number {
          position: relative;
          display: block;
          margin-left: 20px;
          /*
          @include hoverOpacity;
          */
          .tip {
            color: $color-link;
            font-size: 1.4rem;
            position: absolute;
            top: -20px;
            white-space: nowrap;
            opacity: 0;
            transition: opacity .2s;
          }
          &:hover {
            .tip {
              opacity: 1;
            }
          }
          .icn {
            color: $color-link;
          }
        }
        .view,
        .position {
          width: 20px;
          height: 28px;
        }
        .view {
          .tip {
            left: -5px;
          }
          .icn {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate3d(-50%,-50%,0);
          }
        }
        .position {
          .tip {
            left: -25px;
          }
          .icn {
            position: absolute;
            left: 50%;
            transform: translate3d(-50%,0,0);
          }
          .icn-up {
            top: 0;
          }
          .icn-down {
            bottom: 0;
          }
        }
        .number {
          .formparts.select {
            .select-label {
              height: 36px;
              background-color: #fff;
            }
          }
        }
      }     
    }
  }
  &-custom {
    margin-top: 40px;
    text-align: center;
    .text {
      display: inline-block;
      color: $color-link;
      @include hoverOpacity;
    }
  }
  &-footer {
    border-top: 1px solid $color-line;
    margin-top: 80px;
    padding: 40px 40px 120px;
    .list {
      list-style: none;
      font-size: 1.4rem;
      li {
        display: inline-block;
        margin-right: 20px;
        margin-top: 20px;
        a {
          color: $color-link;
          @include hoverOpacity;
        }
      }
      &.sm {
        font-size: 1.2rem;
        li a {
          text-decoration: none;
        }
      }
    }
    .copy {
      margin-top: 40px;
      text-align: right;
      font-size: 1.2rem;
      color: $color-content;
    }
  }
  &-views {
    background-color: $color-bg-form;
    padding: 40px 0;
    margin-bottom: 20px;
    border-bottom: 1px solid $color-line;
    &-container {
      width: 100%;
      max-width: 900px;
      margin: 0 auto;
      padding: 0 20px;
      display: flex;
    }
    .box {
      width: calc(50% - 20px);
      padding: 40px;
      margin: 0 20px;
      border: 1px solid $color-line;
      border-radius: 4px;
      @include hoverOpacity;
      .block {
        display: flex;
        width: 120px;
        margin: 0 auto 20px;
        & > div {
          border: 1px solid $color-line;
          height: 80px;
          border-radius: 2px;
        }
        & > div + div {
          margin-left: 10px;
        }
      }
      .text {
        font-size: 1.6rem;
        text-align: center;
        color: $color-link;
      }
      &.col-1 .block > div {
        width: 100%;
      }
      &.col-2 .block > div {
        width: calc(50% - 5px);
      }
      &.is-active {
        border: 2px solid $color-link;
        background-color: #fff;
        .block > div {
          background-color: $color-link;
          border: none;
        }
      }
    }
  }
  .books {
    .list-package {
      margin-top: 12px;
    }
    .category {
      color: $color-sup;
      margin-top: 20px;
      &:first-child {
        margin-top: 0;
      }
    }
    .dashboard-content {
      overflow-y: auto;
    }
  }
  .document-download {
    .dashboard-content {
      overflow-y: auto;
    }
  }
  .view-lator,
  .knowledge,
  .note,
  .bookmark {
    .list-item {
      display: flex;
      align-items: center;
      .date {
        // width: 110px;
        // padding-right: 20px;
        width: 100px;
      }
    }
  }
  .is-1column {
    .view-lator,
    .knowledge,
    .note,
    .bookmark {
      .list-item {
        .link {
          width: calc(100% - 130px);
        }
      }
    }
  }
  .knowledge {
    .parent-knowledge-category {
      display: inline-block;
      // width: 135px;
      // width: 125px;
      width: 165px;
    }
  }
  .note {
    .list-item {
      position: relative;
      // padding-right: 20px;
      .prof {
        @include profileImage();
      }
    }
  }
  .history-of-view {
    .list-item {
      display: flex;
      align-items: center;
      .date {
        // width: 110px;
        // padding-right: 20px;
        width: 100px;
      }
      .category {
        // width: 130px;
        // padding-right: 20px;
        width: 120px;
      }
      .link {
        width: calc(100% - 280px);
      }
    }
  }
  .pv {
    .list {
      &-item {
        position: relative;
        padding-left: 30px;
        &:before,
        .icn {
          position: absolute;
          font-size: 1.6rem;
        }
        &:before {
          left: 0;
          color: $color-content;
        }
        .icn {
          left: -5px;
          color: $color-yellow;
          font-weight: bold;
        }
        &:nth-child(2):before {
          content: '2';
        }
        &:nth-child(3):before {
          content: '3';
        }
      }
    }
  }
  .information {
    .tab {
      list-style: none;
      margin-bottom: 30px;
      li {
        display: inline-block;
        padding-right: 20px;
        margin-top: 8px;
        color: $color-content;
        @include hoverOpacity;
        &.is-active {
          color: $color-link;
        }
        & + li {
          padding-left: 20px;
          border-left: 1px solid $color-line;
        }
      }
    }
    .list-item {
      .row {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        .date {
          // width: 110px;
          // padding-right: 20px;
          width: 100px;
        }
        .label {
          display: inline-block;
          padding: 0 8px;
          border-radius: 2px;
          color: #fff;
          font-size: 1.6rem;
          margin-right: 20px;
          &.gray {
            background-color: #80889B;
          }
          &.red {
            background-color: #C95656;
          }
        }
        .category {
          color: $color-sup;
          font-size: 1.6rem;
        }
      }
      .detail {
        // margin-left: 110px;
        margin-left: 100px;
        .link {
          display: block;
          margin-bottom: 6px;
          color: $color-link;
          font-size: 1.6rem;
        }
      }
    }
  }
}

.footer-fixed {
  position: fixed;
  bottom: 0;
  z-index: $index-header;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 5px 20px rgba(0,0,0,.16);
  padding: 24px 40px;
  text-align: center;
  .button.save {
    display: inline-block;
    .btn {
      padding: 0 20px;
    }
  }
  .init {
    position: absolute;
    right: 40px;
    top: 50%;
    transform: translate3d(0,-50%,0);
    color: $color-link;
    font-size: 1.4rem;
  }
}
#btnTop.is-slideup {
  bottom: 90px;
}

</style>
